import { httpService } from 'core-utilities';
import { getDevexInfoUrlConfig } from '../constants/devexConstants';

const getDeveloperExchangeInfo = () => {
  const param = {
    fromDevExPage: true
  };
  return httpService.get(getDevexInfoUrlConfig(), param);
};

export default getDeveloperExchangeInfo;
